import marketing from './Marketing';
import marketingFormState from './marketingFormState';

export default {
  marketing,
  marketingFormState,
};
